//-- Copyright (c) 2021 TMT Insights Group, LLC
import { BreadcrumbsProps, Breadcrumbs as MuiBreadcrumbs } from '@mui/material';
import { ReactNode } from 'react';
import styled from '@emotion/styled';

const Breadcrumbs = ({ children, ...props }: BreadcrumbsProps & { children: ReactNode }) => {
  return (
    <Wrapper aria-label="breadcrumb" {...props}>
      {children}
    </Wrapper>
  );
};

export default Breadcrumbs;

const Wrapper = styled(MuiBreadcrumbs)`
  && {
    a {
      text-decoration: none;
      color: ${({ theme }) => theme.palette.primary.main};
    }

    h3 {
      font-size: inherit;
      line-height: 1;
    }

    .MuiBreadcrumbs-separator {
      font-size: 16px;
    }
  }
`;
